import { render, staticRenderFns } from "./MarketOverallProduct.vue?vue&type=template&id=2e8cb4da&scoped=true"
import script from "./MarketOverallProduct.vue?vue&type=script&lang=js"
export * from "./MarketOverallProduct.vue?vue&type=script&lang=js"
import style0 from "./MarketOverallProduct.vue?vue&type=style&index=0&id=2e8cb4da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8cb4da",
  null
  
)

export default component.exports